import { StatusBarStyleEnum } from "@/enums/global";

// Default applied by router afterEach (Task 1.3) if route.meta.statusBarStyle
// is undefined. AQ-8 Option A confirmed 2026-04-24 — Wave 2 ships zero
// per-route overrides; all routes inherit Default.
export const STATUS_BAR_DEFAULT_STYLE = StatusBarStyleEnum.Default;
